import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import { firstApiErrorMessage } from "../../../common/utils"
import { selectProfile } from "../../users/reducer"
import SelectSMSCampaignDialog from "../components/SelectSMSCampaignDialog"
import {
  TrialFinishedRoadblockDialogData,
  useTrialFinishedDialogUtils,
} from "../components/TrialFinishedRoadblockDialog"
import { selectCRMSettings } from "../reducer"
import { SETTINGS_TABS, createSettingsTabURL } from "../settings"
import { getSmsSendingPrerequisiteState } from "../utils"

export default function SendSMSCampaignDialog({ candidate, open, onClose }) {
  const [isSending, setIsSending] = useState(false)
  const [sendError, setSendError] = useState("")
  const axios = useAuthorizedAxiosClient()

  useEffect(() => {
    if (open) {
      setSendError("")
    }
  }, [open])

  function handleSendButtonClicked(selectedCampaign) {
    setIsSending(true)
    setSendError("")
    axios
      .post(`/workflows/api/sms/send-campaign/${selectedCampaign.id}/`, {
        candidate_id: candidate.id,
      })
      .then(({ data }) => {
        onClose(data)
      })
      .catch((err) => {
        setSendError(
          firstApiErrorMessage(
            err?.response?.data,
            "Could not send SMS. Please try again."
          )
        )
      })
      .finally(() => setIsSending(false))
  }

  return (
    <SelectSMSCampaignDialog
      open={open}
      onClose={onClose}
      campaignTextPropName="rendered_text"
      errorMessage={sendError}
      primaryButton={{
        text: "Send",
        onClick: handleSendButtonClicked,
        isLoading: isSending,
      }}
      campaignsAPIURL={`/workflows/api/sms/select-campaign/${candidate.id}/`}
    />
  )
}

export function useManageSendSMSCampaignDialog() {
  const navigate = useNavigate()
  const [sendSMSCampaignDialogOpen, setSendSMSCampaignDialogOpen] =
    useState(false)
  const crmSettings = useSelector(selectCRMSettings)
  const profile = useSelector(selectProfile)
  const { runOnlyIfSubscribed } = useTrialFinishedDialogUtils()

  function handleSendSMSButtonClicked() {
    runOnlyIfSubscribed(() => {
      const smsPrereq = getSmsSendingPrerequisiteState(crmSettings, profile)
      if (!smsPrereq.ready) {
        navigate(
          createSettingsTabURL(SETTINGS_TABS.phoneSms, {
            focus:
              smsPrereq.reason === "concierge_no_phone" ? undefined : "sms",
          })
        )
        return
      }
      setSendSMSCampaignDialogOpen(true)
    }, new TrialFinishedRoadblockDialogData("Sending SMS", "Subscribe to gain back the ability to send SMS to your candidates"))
  }

  return {
    sendSMSCampaignDialogOpen,
    setSendSMSCampaignDialogOpen,
    handleSendSMSButtonClicked,
  }
}
